import {ItemSubType, ItemType, ItemTypeDetail} from '../../generated/types';

type Genus = 'male' | 'female' | 'other' | 'multiple';

/** Книжный тип под названием предмета */
export const ItemTypeNames: Record<ItemType, {genus: Genus; title: string; subTypeAnyTherm?: string}> = {
	Weapon: {genus: 'other', title: 'Оружие', subTypeAnyTherm: 'любое'},
	Armor: {genus: 'female', title: 'Броня', subTypeAnyTherm: 'любая'},
	Treasure: {genus: 'other', title: 'Сокровище'},
	Ship: {genus: 'male', title: 'Судно'},
	Vehicle: {genus: 'male', title: 'Транспорт'},
	TradeBar: {genus: 'male', title: 'Слиток'},
	TradeGood: {genus: 'multiple', title: 'Товары'},
	ArtisansTools: {genus: 'multiple', title: 'Инструменты ремесленника'},
	Explosive: {genus: 'female', title: 'Взрывчатка'},
	FoodAndDrink: {genus: 'multiple', title: 'Пища и питьё'},
	AdventuringGear: {genus: 'other', title: 'Снаряжение искателя приключений'},
	GamingSet: {genus: 'female', title: 'Настольная игра'},
	Tool: {genus: 'male', title: 'Инструмент'},
	TackAndHarness: {genus: 'multiple', title: 'Упряжь и уход'},
	Rod: {genus: 'male', title: 'Скипетр'},
	Wand: {genus: 'male', title: 'Жезл'},
	Ring: {genus: 'other', title: 'Кольцо'},
	Mount: {genus: 'male', title: 'Скакун'},
	Potion: {genus: 'other', title: 'Зелье'},
	Poison: {genus: 'male', title: 'Яд'},
	Scroll: {genus: 'male', title: 'Свиток'},
	SpellcastingFocus: {genus: 'male', title: 'Фокусирующий предмет'},
	Staff: {genus: 'male', title: 'Посох'},
};

/** Подтип: подпись в фильтре и уточнение в скобках, если другого уточнения у предмета нет */
export const ItemSubTypeNames: Record<ItemSubType, {title: string; default?: string}> = {
	Melee: {title: 'Ближнего боя'},
	Ranged: {title: 'Дистанционное'},
	Ammunition: {title: 'Боеприпас', default: 'боеприпас'},
	Light: {title: 'Лёгкая'},
	Medium: {title: 'Средняя'},
	Heavy: {title: 'Тяжёлая'},
	Shield: {title: 'Щит'},
	Gemstone: {title: 'Самоцвет'},
	ArtObject: {title: 'Предмет искусства'},
	Water: {title: 'Водное', default: 'водное'},
	Air: {title: 'Воздушное', default: 'воздушное'},
	Instrument: {title: 'Музыкальный инструмент', default: 'музыкальный'},
};

/** Подробные коды из requires и excludes: из них складывается «Броня (лёгкая, средняя или тяжёлая)» */
export const ItemTypeDetailNames: Record<ItemTypeDetail, {subTypeAnyTherm?: string; subType?: string}> = {
	Rod: {},
	Wand: {},
	AdventuringGear: {},
	TradeGood: {},
	Other: {},
	VehicleAir: {},
	ArtisansTools: {},
	FoodAndDrink: {},
	TreasureArtObject: {},
	TreasureGemstone: {},
	SpellcastingFocus: {},
	Shield: {subType: 'Щит', subTypeAnyTherm: ''},
	HeavyArmor: {subType: 'тяжёлая'},
	MediumArmor: {subType: 'средняя'},
	LightArmor: {subType: 'лёгкая'},
	AnimalArmor: {},
	MeleeWeapon: {subType: 'оружие ближнего боя'},
	Instrument: {},
	TackAndHarness: {},
	Explosive: {},
	Mount: {},
	VehicleLand: {},
	GamingSet: {},
	Tool: {},
	Potion: {},
	Poison: {},
	VehicleWater: {},
	RangedWeapon: {},
	Ring: {},
	Scroll: {},
	Ammunition: {},
	AmmunitionFirearms: {},
	BurstFire: {},
	Staff: {},
	TradeBar: {},
	AnyArmor: {subTypeAnyTherm: 'любая'},
	AnyAmmunition: {subTypeAnyTherm: 'любой', subType: 'Боеприпас'},
	AnyWeapon: {subTypeAnyTherm: 'любое'},
};
